import React, { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import Illustration from "./Illustration";
import ActionRequiredComponent from "./ActionRequiredComponent";
import CaseManagementComponent from "./CaseManagementComponent";
import Ageing from "./ageing";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { caseManagementMenuReducer } from "../../Redux/Slice/CaseManagementMenuSlice";
import { useNavigate } from "react-router-dom";
import { tabReducer } from "../../Redux/Slice/SideBarSlice";
import { analyticsPageview } from "../../Utils/helper";
import Explainer from "../../AppTour/Explainer";
import "./styles.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );

  const onCLickCaseManagementComponentPill = (tabVal, tabIndex) => {
    dispatch(
      caseManagementMenuReducer({
        caseManagementMenuTab: tabVal.split(" ")[1],
        caseManagementMenuTabIndex:
          userRole === "QC" && tabIndex > 1 ? tabIndex - 1 : tabIndex,
      })
    );
    dispatch(tabReducer("CaseManagementTab"));
    navigate("/caseManagement");
  };

  useEffect(() => {
    //Google Analytics Page View Event
    analyticsPageview("pageview", window?.location?.pathname, "Home Page View");
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Illustration />
      <Explainer />
      <Box
        sx={{ ml: "2.4rem", mt: { sm: "2.5rem", md: "3.5rem", lg: "3.5rem" } }}
      >
        <Grid container spacing={2}>
          <Grid item md={4}>
            <CaseManagementComponent
              onClick={onCLickCaseManagementComponentPill}
            />
          </Grid>
          <Grid item md={4} width={"100%"}>
            <Ageing />
          </Grid>
          <Grid item md={4} width={"100%"}>
            <ActionRequiredComponent />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
